export default __webpack_public_path__ + "static/media/danaRegular.95d30469.woff2";